import type { Schema } from '@fhs/client';
import type { LoyaltyOffer } from '@fhs-legacy/frontend/src/state/loyalty/types';

const POINTS_INCENTIVE_TYPE = 'POINTS' satisfies Schema['OfferIncentiveType']['type'];

/** Points offers grant bonus points (flat or multiplier) instead of a discount. */
export function isPointsIncentiveType(
  incentiveType: unknown
): incentiveType is typeof POINTS_INCENTIVE_TYPE {
  return incentiveType === POINTS_INCENTIVE_TYPE;
}

/**
 * Checks the selected cart offer. V2 offers are stored as `LoyaltyOffer`, but their incentives
 * carry an `incentiveType` that the generated incentive union does not declare.
 */
export function isPointsCartOffer(offer: LoyaltyOffer | null | undefined): boolean {
  return !!offer?.incentives?.some(
    incentive =>
      !!incentive && 'incentiveType' in incentive && isPointsIncentiveType(incentive.incentiveType)
  );
}

/** Shown when a points offer is blocked because the guest reached the daily points-earning limit. */
export const MAX_TRANSACTIONS_MESSAGE =
  "You've reached today's limit of orders that earn points. Use this offer again tomorrow.";

/** Shown when a points offer is blocked because the account cannot earn points. */
export const POINTS_EARNING_DISABLED_MESSAGE =
  "Your account can't earn points right now, so this offer isn't available.";
